import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../common/elements";

@customElement("eop-hover-trigger")
export class EopHoverTrigger extends UnLitElement {

    @property({attribute: "hover-elements-selector", type: String})
    public hoverElementsSelector: string = ":scope:not(*)";

    private hoverElements: NodeListOf<Element>;

    public connectedCallback(): void {
        super.connectedCallback();
        this.hoverElements = this.querySelectorAll(this.hoverElementsSelector);
        this.addEventListener("mouseover", () => {
            this.hoverElements.forEach(element => element.classList.add("hover"));
        });
        this.addEventListener("mouseout", () => {
            this.hoverElements.forEach(element => element.classList.remove("hover"));
        });
    }
}